import React from "react";

import { Button } from "@mui/material";


import * as Api from 'api/api';
// import * as UsersApi from 'api/users';
import { ApiUser } from "api/users";


import * as F from 'tsui/Form';
import PageContents from "components/PageContents";

import UserCardsCollection from "./UserCardsCollection";
import SimpleDialog from "./UserCardsCollection";


interface UserDetailsTabProps {
    userId: string;
    onClose: () => void;

}





export default function UserDetailsTab(props: UserDetailsTabProps) {
    // const mounted = React.useRef(false);
    // const [dataRequested, setDataRequested] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(null);
    const [userCardsCollection, setUserCardsCollection] = React.useState(false);
    // const [userData, setUserData] = React.useState<UsersApi.ApiUser | null>(null);
    const [data, setData] = React.useState<ApiUser | null>(null);
    const [userCardsArray, setUserCardsArray] = React.useState([]);

    const form = F.useUpdateForm();

    const [open, setOpen] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState('asds');


    const onSubmit = React.useCallback((evt: F.InputFormEvent) => {
        evt.data.userId = props.userId

        // Api.requestSession<any>('admin', 'update_user', evt.data).then(d => {
        Api.requestSession<any>('users', 'update', evt.data).then(d => {

            props.onClose();
            // console.log(`modified count is ${d.modifiedCount}`)
        }).catch(err => console.log(err));
        

    }, []);
    
    const onClick = React.useCallback(() => {

        
        Api.requestSession<any>('users', 'get_cards_collection', {userId: props.userId}).then(d => {
    
            console.log('d', d)
            setUserCardsArray(d)
            setUserCardsCollection(true)
        }).catch(err => console.log(err));

        // alert('congratulations')
       
    }, []);



console.log('props.userId', props.userId)

    return <F.FormDataProvider<ApiUser> apiGroup="users" apiCommand="get" apiParams={{userId:props.userId}} onData={d => {
        console.log(d) 
        setData(d)}
     } form={form}>
        <F.PageFormDialog title='User' form={form} size='md' onSubmit={onSubmit} onClose={props.onClose}>
            {/* <Form.InputGroup label='Email' form={form} /> */}

            <F.InputGroup label='Contacts' form={form} />
            <F.InputText label='Email' id='email' validate="email" autocomplete='email' required value={data?.email} form={form} xs={7}/>
            {data?.phone &&   <F.InputText label='Phone' id='phone' value={data?.phone} validate='off' autocomplete='given-name'  form={form} xsThird/>}

            <F.InputGroup label='Name' form={form} />
            <F.InputText label='First Name' id='firstName' value={data?.firstName} validate='off' autocomplete='given-name'  form={form} xsThird/>
            <F.InputText label='Last Name' id='lastName' value={data?.lastName} validate='off' autocomplete='family-name'  form={form} xsThird/>
            
            <Button variant='contained' sx={{ marginLeft: 5 }} onClick={onClick}>Cards</Button>

         
        </F.PageFormDialog>

        {userCardsCollection && <UserCardsCollection open={userCardsCollection} selectedValue={selectedValue}  userCards={userCardsArray} userId={props.userId} onClose={() => {setUserCardsCollection(false)}}/>}

    </F.FormDataProvider>
    }



    // import React from "react";

    // import * as Api from 'api';
    // // import * as UsersApi from 'api/users';
    // import { ApiUser } from "api/users";
    
    // import * as Form from 'components/Form';
    // import { useApiData } from "components/ApiDataProvider";
    
    
    // interface UserDetailsTabProps {
    //     userId: string;
    //     onClose: () => void;
    // }
    
      
    
    // export default function UserDetailsTab(props: UserDetailsTabProps) {
       
    //     const form = Form.useForm();
    
    //     const dataState = useApiData<Api.ApiUser>({
    //         apiGroup: 'admin',
    //         apiCommand: 'fetch_user',
    //         apiParams: {userId: props.userId},
    //         form: form,
    //         // onData: (data) => processScanDataItem(data),
    //     });
    //     // React.useEffect(() => {
    //     //     mounted.current = true;
    //     //     if (!dataRequested) {
    //     //         Api.requestAdmin<UsersApi.ApiUser>('admin', 'fetch_user', {userId: props.userId}).then(user => {
    //     //             if (mounted.current){
    //     //                 setUserData(user);
    //     //             } 
    //     //         }).catch(err => {
    //     //             setErrorMessage(err.message)
    //     //         });
    //     //         setDataRequested(true);
    //     //         return;
    //     //     }
    //     //     return () => {mounted.current = false}
    //     // }, [dataRequested]);
    
    //     // return <PageDialog 
    //     //     title={'User'} 
    //     //     size={'sm'}
    //     //     errorMessage={errorMessage}
    //     //     dataLoading={!userData}
    //     //     onClose={props.onClose}
    //     // >
    //     //     <PageDataGrid>
    //     //         <GridTextField xs={12} md={12} label='Email' value={userData?.email}/>
    //     //         <GridTextField xs={4} md={3} label='First Name' value={userData?.firstName}/>
    //     //         <GridTextField xs={4} md={3} label='Last Name' value={userData?.lastName}/>
    //     //     </PageDataGrid>
    
    //     // </PageDialog>;
    
    //     const onSubmit = React.useCallback((evt: Form.InputFormEvent) => {
    //         if (form.error)
    //             return;
    //         props.onClose();
    //     }, []);
    
    //     let data = dataState.data;
    
    //     return <>
    //         <Form.DialogInputForm title={'User: ' + props.userId} show={true} form={form} size='lg' onSubmit={onSubmit} onClose={props.onClose}>
    //             <Form.InputText label='User Id' id='userId' form={form} readonly value={data?.userId} xsThird />
    //             <Form.InputText label='User First Name' id='firstName' form={form} readonly value={data?.firstName} xsThird />
    //             <Form.InputText label='User Last Name' id='lastName' form={form} readonly value={data?.lastName} xsThird />
    //             {/* <Form.InputGroup label='Email' form={form} /> */}
    //             <Form.InputText label='Email' id='email' validate="email" autocomplete='email' readonly value={data?.email} form={form} xs={7}/>
    
    //         </Form.DialogInputForm>
    //     </>;
    //     }
    